import validate from '../../../services/reduxValidate.js'
import { isEmpty } from '../../../../shared/services/lodashInJS.js'

export default function(data) {
  const linkedinUrlPattern = /(http(s)?:\/\/)?(www\.)?linkedin.com\/in\/[A-z0-9-%ÀàÁáÂâÃãÄäÅåÆæÇçÐðÈèÉéÊêËëÌìÍíÎîÏïÑñÒòÓóÔôÕõÖöœŒØøßÙùÚúÛûÜüÝýÞþŸÿ]+(\/)?/

  const validators = {
    'user.firstname': { presence: { allowEmpty: false } },
    'user.lastname': { presence: { allowEmpty: false } },
    'user.date_of_birth': { isoDate: true },
    'user.company': {
      length: {
        maximum: 45,
        message: 'Le nom de votre entreprise ne peut pas dépasser 45 caractères.'
      }
    },
    'user.tel': {
      presence: { allowEmpty: false },
      format: {
        pattern: /^\+?([0-9.\-\s]+)$/g,
        message: "Le numéro de téléphone est invalide (format souhaité : +33612345678)"
      }
    },
    'freelance.title': {
      presence: { allowEmpty: false },
      length: {
        maximum: 128,
        message: 'Le titre de votre fiche ne peut pas dépasser 128 caractères.'
      }
    },
    'freelance.summary': {
      length: {
        maximum: 1300,
        message: 'Vos attentes ne peut pas dépasser 1300 caractères.'
      }
    },
    // 'user.linkedin_url': {
    //   url: {message: 'L\'url est invalide.'},
    //   presence: {allowEmpty: true},
    //   format: {pattern: linkedinUrlPattern, message: 'L\'url est invalide.'}
    // }
  }

  if (!isEmpty(data?.user.linkedin_url ?? null)) {
    validators['user.linkedin_url'] = {
      url: {message: 'L\'url est invalide.'},
      presence: {allowEmpty: true},
      format: {pattern: linkedinUrlPattern, message: 'L\'url est invalide.'}
    }
  }

  return validate(data, validators)
}
